<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="activeNameClick">
      <el-tab-pane v-for="listItem in list" :key="listItem.queue_id" :label="listItem.queue_name" :name="listItem.queue_id + ''">
        <el-tabs v-model="activeType" type="border-card">
          <el-tab-pane label="人员分配" name="staff">
            <el-tabs v-model="queueActiveName" v-if="listItem.allChildren" style="margin-top: -10px;">
              <el-tab-pane
                v-for="item in listItem.allChildren"
                :key="item.queue_id"
                :name="item.queue_id + ''"
              >
                <div slot="label">
                  <span>{{ item.queue_name }}</span>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    v-if="item.type == 2"
                  >
                    <div>
                      {{ getConfigName(item.config) }}
                    </div>
                    <i slot="reference" class="el-icon-warning-outline ml5"></i>
                  </el-popover>
                </div>
                <template v-if="item.queue_id == queueActiveName">
                  <Products :products="item.products"/>
                  <div :class="$style.mode">
                    <div v-if="!setting">
                      分配模式：{{ patternMap[item.pattern] }}模式
                      <el-button v-per="['AllotModel_Button_Config']" size="mini" @click="setMode(item)">设置</el-button>
                    </div>
                    <div v-else :class="$style.radioBox">
                      分配模式：
                      <el-radio-group v-model="setPattern" @input="patternChange(item)">
                        <el-radio :label="1">队列分配模式（按队列设置）</el-radio>
                        <el-radio :label="4">部门对应模式</el-radio>
                        <el-radio :label="2">经理模式（客户全部分配至经理岗位）</el-radio>
                        <el-radio :label="3">名单数量目标模式（按员工名单）</el-radio>
                      </el-radio-group>
                      <div>
                        <el-button size="mini" @click="editMode(item)">确定</el-button>
                        <el-button size="mini" @click="cancelSet">取消</el-button>
                      </div>
                    </div>
                  </div>

                  <div v-show="setPattern === 1">
                    <QueueMode :item="item" />
                  </div>
                  <div v-show="setPattern === 2">
                    <div v-if="setting">
                      <div v-for="dep in form" :key="dep.dep_id" style="margin-top: 10px">
                        <span class="mr10">
                          {{ depName(dep.dep_id, item) }}
                        </span>
                        <span>
                          <el-select filterable v-model="dep.user_id" style="width: 200px !important">
                            <el-option
                              v-for="item in depUser[dep.dep_id]"
                              :key="item.id"
                              :label="`${item.username} ${item.realname}`"
                              :value="item.id"
                            />
                          </el-select>
                        </span>
                        <span class="ml30 mr10">分配权重</span>
                        <span>
                          <el-input-number
                            class="w80"
                            :controls="false"
                            v-model="dep.allocation_times"
                            :min="0"
                            :step="1"
                            :max="20"
                            step-strictly
                            placeholder="0~20"
                          ></el-input-number>
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="dep in item.manager" :key="dep.dep_id" style="margin-top: 10px">
                        <span style="margin-right: 10px">
                          {{ depName(dep.dep_id, item) }}
                        </span>
                        <template v-if="dep.username">
                          <span style="margin-right: 10px">
                            {{ dep.username }}
                          </span>
                          <span>
                            {{ dep.realname }}
                          </span>
                        </template>
                        <template v-else> - </template>
                      </div>
                    </div>
                  </div>
                  <div v-show="setPattern === 3">
                    <NameMode :item="item" />
                  </div>
                  <div v-show="setPattern === 4">
                    <div v-if="setting">
                      <div v-for="dep in form" :key="dep.dep_id" class="flex-ac mt10">
                        <span class="mr10">
                          {{ depName(dep.dep_id, item) }}
                        </span>
                        <el-select filterable v-model="dep.user_id" style="width: 200px !important">
                          <el-option
                            v-for="item in depUser[dep.dep_id]"
                            :key="item.id"
                            :label="`${item.username} ${item.realname}`"
                            :value="item.id"
                          />
                        </el-select>
                        <el-checkbox class="ml30" v-model="dep.allocation_times" :true-label="1" :false-label="0">强制新增</el-checkbox>
                        <span>（关闭后只判断当前部门是否存在关系链，如存在则不做新增）</span>
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="dep in item.manager" :key="dep.dep_id" style="margin-top: 10px">
                        <span style="margin-right: 10px">
                          {{ depName(dep.dep_id, item) }}
                        </span>
                        <template v-if="dep.username">
                          <span style="margin-right: 10px">
                            {{ dep.username }}
                          </span>
                          <span>
                            {{ dep.realname }}
                          </span>
                        </template>
                        <template v-else> - </template>
                      </div>
                    </div>
                  </div>
                </template>
              </el-tab-pane>
          </el-tabs>
          </el-tab-pane>
          <el-tab-pane label="直播室分配" name="liveRoom">
            <Products :products="listItem.products"/>
            <div class="flex-ac mt20 mb10 fs14">
              <span>配置启用设置</span>
              <el-switch
                class="ml20 mr20"
                v-model="listItem.live_room_allocation"
                :disabled="liveRoomAllocationSetDisabled"
                @change="onLiveRoomAllocationChange(listItem, $event)"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
              <span style="color: #64948f">*如关闭此选项则不进行直播室分配</span>
            </div>
            <LiveRoomAllocationSet
              v-show="!!listItem.live_room_allocation"
              :data="listItem.live_room_allocation_set"
              :disabled="liveRoomAllocationSetDisabled"
              :queue="listItem"
              :rooms="rooms"
              @update="onUpdated"
              v-loading="updateLoading"
            />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getQueueIndex, getDepUser, editMode, getRoomLists, setLiveRoomAllocationSet } from "./api";
import QueueMode from "./QueueMode.vue";
import NameMode from "./NameMode.vue";
import { amountOptionMap } from '@/modules/queue'
import Products from './Products.vue'
import LiveRoomAllocationSet from './LiveRoomAllocationSet.vue'
import { hasPermission } from '@/permission/index'
export default {
  name: "NameAllot",
  components: {
    QueueMode,
    NameMode,
    Products,
    LiveRoomAllocationSet
  },
  props: {
    branch: {
      type: Object,
    },
  },
  data() {
    const liveRoomAllocationSetDisabled = !hasPermission('AllotModel_Tab_LiveRoomAllocationSetEditable')
    return {
      list: [],
      activeName: "",
      queueActiveName: '',
      setting: false,
      setPattern: 1,
      form: [],
      depUser: {},
      patternMap: {
        1: "队列分配",
        2: "经理",
        3: "名单目标数量",
        4: "部门对应模式"
      },
      activeType: 'staff',
      liveRoomAllocationSetDisabled,
      rooms: [],
      updateLoading: false,
    };
  },
  async beforeMount() {
    await this.getQueueIndex();
  },
  mounted() {
    this.getRooms()
  },
  watch: {
    // activeName(val) {
    //   this.queueActiveName = val
    // },
    queueActiveName() {
      this.cancelSet();
    }
  },
  methods: {
    activeNameClick(val) {
      this.queueActiveName = val.name
    },
    getConfigName(val) {
      const valArr = val.split(',')
      return valArr?.map(key => amountOptionMap[key])?.join('，')
    },
    async getRooms() {
      const { data } = await getRoomLists({center: this.branch.center})
      this.rooms = data
    },
    async getQueueIndex() {
      let { data } = await getQueueIndex({ branch: this.branch.id });
      this.list = data?.map(item => {
        let defaultQueue = {
          ...item,
          queue_name: '默认分配'
        }
        delete defaultQueue.children
        let children = item.children || []
        item.allChildren = [
          defaultQueue,
          ...children
        ]
        return item
      }) || [];
      this.activeName = String(!!this.list[0] && this.list[0].queue_id + "");
      this.queueActiveName = this.activeName
      this.setPattern = !!this.list[0] && this.list[0].pattern;
    },
    cancelSet() {
      this.setting = false;
      const allQueue = this.list.reduce((arr, cur) => {
        arr.push(...cur.allChildren)
        return arr
      }, [])
      let obj = allQueue.find((item) => item.queue_id == this.queueActiveName);
      this.setPattern = !!obj && obj.pattern;
      this.form = [];
      this.depUser = {};
    },
    depName(depId, item) {
      const result = item.receive_dep_des.find((dep) => dep.dep_id == depId);
      return result && result["dep_name"];
    },
    setMode(item) {
      this.setting = true;
      this.patternChange(item)
      item.manager.forEach((item) => {
        let asyncGetDepUser = async () => {
          let { data } =  await getDepUser({ dep_id: item.dep_id });
          this.$set(this.depUser, item.dep_id, data)
        }
        asyncGetDepUser()
      });
    },
    patternChange(item) {
      let formInit = item.manager.map((item) => {
        let allocation_times = item.allocation_times || 0
        if (this.setPattern === 4) {
          allocation_times = allocation_times == 1 ? 1 : 0
        }
        return ({
          dep_id: item.dep_id,
          user_id: item.user_id,
          allocation_times,
        })
      });
      this.$set(this, 'form', formInit)
    },
    async editMode(item) {
      let confirm = await this.$confirm(
        `${item.queue_name}分配模式即将变更为${this.patternMap[this.setPattern]}模式，确认变更吗？`,
        "",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      );
      if (confirm !== "confirm") return;
      let rep = await editMode({
        queue_id: item.queue_id,
        dep_manager: [2, 4].includes(this.setPattern) ? JSON.stringify(this.form) : null,
        pattern: this.setPattern,
      });
      let { code, msg } = await rep.json();
      if (code !== 200) {
        this.$message.error(msg);
        return;
      }
      let activeName = this.activeName;
      let queueActiveName = this.queueActiveName;
      this.$message.success("变更成功");
      try {
        await this.getQueueIndex();
        this.activeName = activeName;
        this.queueActiveName = queueActiveName;
      } finally {
        this.cancelSet();
      }
    },
    async onUpdated() {
      this.updateLoading = true
      let activeName = this.activeName;
      let queueActiveName = this.queueActiveName;
      try {
        await this.getQueueIndex();
        this.activeName = activeName;
        this.queueActiveName = queueActiveName;
      } finally {
        this.updateLoading = false
      }
    },
    async onLiveRoomAllocationChange(item, newValue) {
      if (this.isLiveRoomAllocationSetLoading) return
      item.live_room_allocation = newValue ? 0 : 1
      this.isLiveRoomAllocationSetLoading = true
      try {
        const { code } = await setLiveRoomAllocationSet({
          id: item.queue_id,
          set: newValue
        })
        if (code !== 200 ) {
          throw code
        }
        item.live_room_allocation = newValue
      } catch {
        // item.live_room_allocation = newValue ? 0 : 1
      } finally {
        this.isLiveRoomAllocationSetLoading = false
      }
    }
  },
};
</script>

<style lang="scss" module>
.mode {
  margin: 10px 0;
  font-size: 14px;
}
.radioBox {
  display: flex;
  align-items: center;
}
</style>
